<template>
  <div class="custom custom-common">
    <!-- <div style="word-break: break-all;white-space: pre-wrap;">{{JSON.stringify(Modal)}}</div> -->
    <div class="custom-tool">
      <div class="ct-box">
        <div class="ctb-item" v-for="(component, index) in Modal" :key="'components-' + index">
          <component
            :is="component.componentName"
            :info="component"
            :index="index"
            :type="type"
            @closeModel="closeModel(index, $event)"
            @close="delComponent(index)"
            @add="addComponentsByPosition"
            v-model="component.config"
            :key="'sub-components-' + index"
          ></component>
        </div>
      </div>
      <div class="ct-components">
        <div class="ctc-title">Add</div>
        <div class="ctc-group">
          <div
            class="ctc-item"
            v-for="(item, index) in commmonArr"
            :key="'commmon-' + index"
            @click="addComponents(item)"
          >
            <i class="icon iconfont" :class="item.icon"></i>
            <div class="ctc-item-txt">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import customText from "@components/En/custom-component/common/custom-text/custom-text.vue";
import customPicture from "@components/En/custom-component/common/custom-picture/custom-picture.vue";
import customVideo from "@components/En/custom-component/common/custom-video/custom-video.vue";
import customTitle from "@components/En/custom-component/common/custom-title/custom-title.vue";
import customSearch from "@components/En/custom-component/common/custom-search/custom-search.vue";

export default {
  name: "custom-component-common", // 通用版 区别产品分组 （改变样式）
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    Modal: {
      type: Array,
      default: []
    },
    type: {
      // 通用添加组件的列表   1：所有列表   2：筛选列表
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      commmonArr: [
        {
          title: "Text",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "Picture",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "Video",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ]
    };
  },
  components: {
    customText,
    customPicture,
    customVideo,
    customTitle,
    customSearch
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex"
    }),
    addComponents(item) {
      let copyData = JSON.parse(JSON.stringify(this.Modal));
      let copyItem = [];
      if (item.componentName === "customText") {
        copyItem = {
          title: "Text",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        };
      }
      if (item.componentName === "customPicture") {
        copyItem = {
          title: "Picture",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        };
      }
      if (item.componentName === "customVideo") {
        copyItem = {
          title: "Video",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 视频类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        };
      }
      this.setActiveIndex(copyData.length);
      copyData.push(copyItem);
      this.$emit("change", copyData);
    },
    addComponentsByPosition(item, index) {
      let copyData = JSON.parse(JSON.stringify(this.Modal)); 
      let copyItem = [];
      if (item.componentName === "customText") {
        copyItem = {
          title: "Text",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        };
      }
      if (item.componentName === "customPicture") {
        copyItem = {
          title: "Picture",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        };
      }
      if (item.componentName === "customVideo") {
        copyItem = {
          title: "Video",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 视频类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        };
      }
      copyData.splice(index, 0, copyItem);
      this.setActiveIndex(index);
      this.$emit("change", copyData);
    },
    delComponent(i) {
      let modal = this.Modal.filter((c, idx) => {
        return idx !== i;
      });
      this.$emit("change", modal);
      // this.$emit("sendModal", modal);
    },
    closeModel(i, e) {
      this.Modal.forEach((c, idx) => {
        let name = c.componentName + i;
        if (idx !== i) {
          if (this.$refs[name]) {
            this.$refs[name][0].hide(false);
          }
        }
      });
    },
    saveCustom() {
      let customData = [];
      this.Modal.forEach(e => {
        customData.push({
          [e.type]: e.config
        });
      });
      this.$emit("sendModal", customData);
    }
  },
  destroyed() {
    this.setActiveIndex(-1);
  }
};
</script>

<style scoped lang="scss">
.custom {
  width: 968px;
  margin: 0 auto;
  &-tool {
    width: 375px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    position: relative;
    transition: all 1.2s;
    &:hover {
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    }
    .ct {
      &-head {
        position: absolute;
        top: 0;
        left: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &-box {
        min-height: 320px;
        background: #f5f5f5;
        padding-bottom: 10px;
      }
      &-components {
        .ctc {
          &-title {
            padding: 10px 20px;
            font-size: 14px;
            color: #333;
          }
          &-group {
            padding: 0 20px 10px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
          }
          &-item {
            width: 95px;
            height: 60px;
            margin-bottom: 10px;
            background-color: #ebebeb;
            text-align: center;
            padding-top: 5px;
            cursor: pointer;
            .iconfont {
              font-size: 20px;
              color: #222;
            }
            &-txt {
              width: 100%;
              font-size: 12px;
              color: #222;
              // line-height: initial;
              line-height: 1;
            }
          }
        }
      }
    }
  }
  &-btn {
    box-shadow: 0px 0px 5px 0px rgba(165, 165, 165, 0.2);
    position: fixed;
    bottom: 0;
    z-index: 10;
    background: #fff;
    padding: 10px;
    border-top: none;
    width: 968px;
    text-align: center;
  }
}
</style>
<style lang="scss">
.custom-common {
  .custom-add-wrapper.z-top {
    top: -3px;
  }
  .custom-add-wrapper.z-bottom {
    bottom: 0;
  }
}
</style>
